import { VideoOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type StreamVideoParticipant = {
  size: 'small' | 'large';
};

export const VideoPlaceholder = ({ size }: StreamVideoParticipant) => {
  const { t } = useTranslation();

  return (
    <div className="px-6 h-full w-full bg-slate-800 flex flex-col space-y-2 items-center justify-center text-center rounded-lg text-slate-600">
      <div className={`${size == 'large' ? 'h-32 w-32' : 'h-16 w-16'}`}>
        <VideoOff className={`${size == 'large' ? 'h-32 w-32' : 'h-16 w-16'}`} />
      </div>

      <p className={`${size == 'large' ? 'text-2xl' : 'hidden'} font-bold`}>
        {t('video_call.psychologistCameraDisabled')}
      </p>
    </div>
  );
};
